import { groupBy, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import PassCard, { passPropType } from './pass_card';

const PassGroup = ({ title, passes }) => (
  <div className="mb-4">
    <h5 className="mb-2">{title}</h5>
    <div className="d-flex flex-column gap-2">
      {passes.map((pass) => (
        <PassCard key={pass.uid} pass={pass} />
      ))}
    </div>
  </div>
);

PassGroup.propTypes = {
  title: PropTypes.string.isRequired,
  passes: PropTypes.arrayOf(passPropType).isRequired,
};

const WalletPasses = ({ walletPasses }) => {
  if (isEmpty(walletPasses)) {
    return null;
  }

  // Separate passes with route_name from those without
  const passesWithRoute = walletPasses.filter((pass) => pass.route_name);
  const passesWithoutRoute = walletPasses.filter((pass) => !pass.route_name);

  // Group passes with route by route_name
  const groupedByRoute = groupBy(passesWithRoute, 'route_name');

  // Group passes without route by resource_name
  const groupedByResource = groupBy(passesWithoutRoute, 'resource_name');

  return (
    <div className="mt-4">
      <h5 className="mb-3">Tickets</h5>

      {/* Render passes grouped by route_name */}
      {Object.entries(groupedByRoute).map(([routeName, passes]) => (
        <PassGroup key={routeName} title={routeName} passes={passes} />
      ))}

      {/* Render passes without route, grouped by resource_name */}
      {Object.entries(groupedByResource).map(([resourceName, passes]) => (
        <PassGroup key={resourceName} title={resourceName} passes={passes} />
      ))}
    </div>
  );
};

WalletPasses.propTypes = {
  walletPasses: PropTypes.arrayOf(
    PropTypes.shape({
      uid: PropTypes.string.isRequired,
      reference: PropTypes.string,
      resource_name: PropTypes.string.isRequired,
      first_travel_date: PropTypes.string,
      consumer_type: PropTypes.string,
      consumer_name: PropTypes.string,
      route_name: PropTypes.string,
      apple_wallet_url: PropTypes.string.isRequired,
    })
  ),
};

WalletPasses.defaultProps = {
  walletPasses: [],
};

export default WalletPasses;
